<template>
    <div style="height: 100%; width: 100%;">
        <div class="custom-container" >
            <v-row no-gutters justify="center">
                <v-col cols="12">
                    <v-card flat>
                        <v-card-title class="headline">
                            Mitarbeiter Ansicht
                        </v-card-title>
                    </v-card>
                    <v-card flat v-if="$route.params.id">
                        <AppUtilityUserCard v-if="user.id" :readonly="true" :payload="user"/>
                    </v-card>
                    <v-card class="mt-4">
                        <v-card-title>
                            Mitarbeitergespräche die mit dem Mitarbeiter geführt wurden
                            <v-spacer/>
                            <v-btn v-if="type !== 'hr-department'" color="secondary" :to="{ name: 'EmployeeInterviewsCreate', query: { id: user.id}}"><v-icon>mdi-plus</v-icon>Neues Gespräch </v-btn>
                        </v-card-title>
                        <v-card-title>
                            <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Suchen"
                                    single-line
                                    hide-details
                            ></v-text-field>

                        </v-card-title>
                        <EmployeeInterviewsUtilityInterviewsDataTable :headers="headers" :search="search" :items="interviews" :type="type">
                            <!--Customizing default rows-->
                        </EmployeeInterviewsUtilityInterviewsDataTable>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: [],
        name: "",
        data: () => ({
            search: '',
            user: {},
            interviews: [],
            headers: [
                {
                    text: '#',
                    align: 'start',
                    value: 'identifier'
                },
                { text: 'Datum', value: 'date_interview'},
                { text: 'Durchführende Person', value: 'processing_person'},
                { value: 'action'},
            ],
        }),
        created() {
            if (this.$route.params.id){
                this.getUser(this.$route.params.id);
            }

        },
        computed: {
            type: function (){
                return this.$route.query.type
            }
        },
        methods: {
            ...mapActions({}),
            getUser(id){
                this.axios.get('/users/' + id + '?type=interviews').then( (response) => {
                    this.user = {...response.data.data};
                    this.interviews = Object.values({...response.data.data.interviews});
                });
            }

        },
    }
</script>

<style scoped>

</style>